import { defineStore } from 'pinia';
import { CACHE_KEY, useCache } from '@/hooks/web/useCache'
import { UserInfo } from '@/types/api';
import { loginOut } from '@/api/auth'

const { wsCache } = useCache()

export const useUserStore = defineStore('user', {
  state: (): UserInfo => ({
    userId: '',
    poolNo: '',
    poolName: '',
    poolLogo: '',
    nickName: '',
  }),
  getters: {
    getUserId(): string {
      return this.userId;
    },
    getPoolNo(): string {
      return this.poolNo;
    },
    getPoolName(): string {
      return this.poolName;
    },
    getPoolLogo(): string {
      return this.poolLogo;
    },
    getNickName(): string {
      return this.nickName;
    }
  },
  actions: {
    setUserInfo(userInfo: UserInfo | null) {
      this.resetState()
      if (!userInfo) {
        const userInfoCache = wsCache.get(CACHE_KEY.USER)
        userInfo = userInfoCache
      }
      this.userId = userInfo?.userId || ''
      this.poolNo = userInfo?.poolNo || ''
      this.poolName = userInfo?.poolName || ''
      this.poolLogo = userInfo?.poolLogo || ''
      this.nickName = userInfo?.nickName || ''
      wsCache.set(CACHE_KEY.USER, userInfo)
    },
    async logout() {
      try {
        await loginOut();
      } catch (error) {
        console.error('退出登录失败:', error);
      } finally {
        this.clearAuthData();
      }
    },
    clearAuthData() {
      this.resetState()
      wsCache.delete(CACHE_KEY.USER);
      wsCache.delete(CACHE_KEY.UDB_AUTH_CODE);
      document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    },
    resetState() {
      this.userId = '';
      this.poolNo = '';
      this.poolName = '';
      this.poolLogo = '';
      this.nickName = '';
    }
  }
});

// 获取cookie的辅助函数
// function getCookie(name: string): string {
//   const pattern = new RegExp(`(?:^|; )${encodeURIComponent(name)}=([^;]*)`);
//   const matches = document.cookie.match(pattern);
//   return matches ? decodeURIComponent(matches[1]) : '';
// }
